<template>
  <div class="px-8" v-if="modelValue">
    <v-switch
      v-model="modelValue.settings.hideCountIfZero"
      label="Show when zero in stock"
      hide-details
      color="primary"
      class="pt-0"
    ></v-switch>
  </div>
</template>

<script setup lang="ts">
import { useSettingsStore } from '@/stores/settings'
import { onMounted, ref, watch } from 'vue'

const emit = defineEmits(['hide-on-zero-stock'])

const props = defineProps<{
  selectedPlacement: string
  make: string
  model: string
}>()

const showCountIfZero = ref(true)
const settingsStore = useSettingsStore()
const modelValue = ref()

onMounted(() => {
  modelValue.value = settingsStore.placements.placements[
    props.selectedPlacement
  ]['filter'].find((item: any) => {
    return item.make === props.make && item.model === props.model
  })
})

watch(() => modelValue, () => {
  emit('hide-on-zero-stock', modelValue.value.settings.hideCountIfZero)
}, {
  deep: true
})
</script>
